import { Component, Input, signal, Signal, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { first } from 'rxjs/operators';
import { Navigator } from 'src/app/services/routing/navigator';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { LogoutService } from 'src/app/services/logout/logout.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';


@Component({
  selector: 'app-update-toc',
  templateUrl: './update-toc.component.html',
  styleUrls: ['./update-toc.component.scss'],
})
export class UpdateTocComponent {
  @ViewChild('Content') content: IonContent;
  @Input() customerId: any;
  @Input() callBackFn: () => void;

  public error = null;
  public timerId: any;
  public buttonDisabled = false;

  constructor(
    public events: EventsService,
    private userSession: UserSessionService,
    private appLinks: AppLinksService,
    private navigator: Navigator,
    private logoutService: LogoutService,
  ) {
    this.events.publish("event:lobby:hide");
    
    this.timerId = setTimeout(()=> {
      this.closeModal();
    },300000);
  }

  public onAgreeToc() {
    this.buttonDisabled = true;
    this.userSession.acceptTerms(this.customerId).pipe(first()).subscribe(
      response => {
        if (!isUndefined(response) && !!response.result) {
          if (!!this.callBackFn){
            this.callBackFn();
            this.events.publish("event:lobby:show");
            this.navigator.dismiss();
          } 
          clearTimeout(this.timerId);
        } else {
          this.navigator.navigateTo("LogoutPage", { forceModal: true }, { reason: 'TOC_INVALID' });
        }
      },
      error => this.navigator.navigateTo("LogoutPage", { forceModal: true }, { reason: 'TOC_INVALID' })
    )
  }

  openMatchedExternalLinks(code, title) {
    return this.appLinks.openMatchedExternalLinksPopover(code, title);
  }

  closeModal = () => {
    this.navigator.dismiss();
    return this.logoutService.onLogout({ reason: 'TOC_INVALID' });
  }
}
